<template>
  <div :key="id" class="accordion" :class="{ active: isOpen }">
    <h3 class="accordion__heading" :class="{ active: isOpen }">
      <button
        :id="`heading_${id}`"
        :aria-controls="`panel_${id}`"
        :aria-expanded="isOpen ? 'true' : 'false'"
        @click="toggleAccordion"
        :class="isOpen ? 'accordion__toggle--open' : 'accordion__toggle--closed'"
      >
        <span
          :class="
            isOpen
              ? 'accordion__title accordion__title--open'
              : 'accordion__title accordion__title--closed'
          "
          >{{ title }}</span
        >
        <Transition name="fade">
          <icon v-show="!isOpen" glyph="#icon-plus-green" />
        </Transition>
        <Transition name="fade">
          <icon v-show="isOpen" glyph="#icon-minus" />
        </Transition>
      </button>
    </h3>
    <div
      :id="`panel_${id}`"
      role="region"
      :aria-labelledby="`heading_${id}`"
      class="accordion__panel"
      :class="{ active: isOpen }"
      v-bind:inert="!isOpen"
    >
      <div class="accordion__panel--container">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    id: { type: String, default: '' },
    title: { type: String, default: '' }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
    keydown() {
      if (
        event !== null &&
        event.type === 'keydown' &&
        (event.ctrlKey || event.metaKey) &&
        event.keyCode === 70
      ) {
        this.openAccordion();
      }
    },
    openAccordion() {
      if (!this.isOpen) this.isOpen = true;
    }
  },
  created() {
    window.addEventListener('keydown', this.keydown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.keydown);
  }
};
</script>
